import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PostDatedPresDetails {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  PostDatedPresDetailsData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: PostDatedPresDetails = {
  isLoading: false,
  error: false,
  message: null,
  PostDatedPresDetailsData: [],
  Items: [],
  Pagination: [],
};

const PostDatedPresDetailsSlice = createSlice({
  name: "postdatedprescriptiondetails",
  initialState,
  reducers: {
    loadingPostDatedPresDetails: (
      state: PostDatedPresDetails,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setPostDatedPresDetails: (
      state: any,
      action: PayloadAction<PostDatedPresDetails>
    ) => {
      return action.payload;
    },
    clearData: (state: PostDatedPresDetails, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const {
  loadingPostDatedPresDetails,
  setPostDatedPresDetails,
  clearData,
} = PostDatedPresDetailsSlice.actions;
export default PostDatedPresDetailsSlice.reducer;
